// extracted by mini-css-extract-plugin
export var standaloneTable = "_fh-0";
export var withExtraHeader = "_fh-1";